import { render, staticRenderFns } from "./ProductDetailsErrorPage.vue?vue&type=template&id=f45114bc&"
import script from "./ProductDetailsErrorPage.vue?vue&type=script&lang=js&"
export * from "./ProductDetailsErrorPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports